<script lang="ts" setup>
provide('listType', 'ul')
</script>

<template>
  <ul class="ul richtext__usps">
    <slot />
  </ul>
</template>
